import axios from '../utils/axios';

export default function fetchCourseEnquiry(adminId,courseId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course/' + courseId + '/leads',  {params} )
    )
}